module.exports = __webpack_public_path__ + "static/media/left-arrow.75c5c09a.svg";